__turbopack_context__.v({
  "accent-blue": "CaseStudyCard-module-scss-module__7LFHIW__accent-blue",
  "accent-cyan": "CaseStudyCard-module-scss-module__7LFHIW__accent-cyan",
  "accent-graphite": "CaseStudyCard-module-scss-module__7LFHIW__accent-graphite",
  "accent-orange": "CaseStudyCard-module-scss-module__7LFHIW__accent-orange",
  "card": "CaseStudyCard-module-scss-module__7LFHIW__card",
  "chip": "CaseStudyCard-module-scss-module__7LFHIW__chip",
  "chipArrow": "CaseStudyCard-module-scss-module__7LFHIW__chipArrow",
  "chipLabel": "CaseStudyCard-module-scss-module__7LFHIW__chipLabel",
  "chipRoot": "CaseStudyCard-module-scss-module__7LFHIW__chipRoot",
  "chipWrapper": "CaseStudyCard-module-scss-module__7LFHIW__chipWrapper",
  "image": "CaseStudyCard-module-scss-module__7LFHIW__image",
  "imageWrapper": "CaseStudyCard-module-scss-module__7LFHIW__imageWrapper",
  "link": "CaseStudyCard-module-scss-module__7LFHIW__link",
  "position1": "CaseStudyCard-module-scss-module__7LFHIW__position1",
  "position2": "CaseStudyCard-module-scss-module__7LFHIW__position2",
  "position3": "CaseStudyCard-module-scss-module__7LFHIW__position3",
  "position4": "CaseStudyCard-module-scss-module__7LFHIW__position4",
});
